import './App.css';
import Header from './components/Header/Header';
import Lab from './components/Lab/Lab';

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Lab></Lab>

    </div>
  );
}

export default App;
